module.exports = __webpack_public_path__ + "img/family_01_fanfan.9b921fb9.png";